<template>
  <select v-model="internalSelectedCoin" @change="onChange" class="p-2 rounded-l-md rounded-r-none">
    <option value="bitcoin">Bitcoin</option>
    <option value="dacxi">DACXI</option>
    <option value="ethereum">ETH</option>
    <option value="cosmos">ATOM</option>
  </select>
</template>

<script>
export default {
  props: {
    selectedCoin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      internalSelectedCoin: this.selectedCoin,
    };
  },
  watch: {
    selectedCoin(newVal) {
      this.internalSelectedCoin = newVal;
    },
  },
  methods: {
    onChange() {
      this.$emit('coin-changed', this.internalSelectedCoin);
    },
  },
};
</script>
